export const PHONE_MASK = '+7 999 999-99-99';
